//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfBottomNavigation from "~/themes/fiskarsMoominDefault/components/components/organisms/SfBottomNavigation/SfBottomNavigation.vue";
import SfIcon from "~/themes/fiskarsMoominDefault/components/components/atoms/SfIcon/SfIcon.vue";
import SfCircleIcon from "~/themes/fiskarsMoominDefault/components/components/atoms/SfCircleIcon/SfCircleIcon.vue";
import SfBadge from "~/themes/fiskarsMoominDefault/components/components/atoms/SfBadge/SfBadge.vue";
import { useUiState, useUserAccount } from "~/composables";
import { computed, useRouter, useRoute, useContext, watch, onMounted } from "@nuxtjs/composition-api";
import {userCheckoutStore} from "~/stores/checkout-store.js";
import { useVSFContext } from "@vue-storefront/core";
import { checkCMSFlag } from "~/helpers/globalLabels";

export default {
  components: {
    SfBottomNavigation,
    SfIcon,
    SfCircleIcon,
    SfBadge,
  },
  setup() {
    const useCheckoutStore = userCheckoutStore();

    const { isAuthenticated } = useUserAccount('user-account-info');

    const { localePath } = useVSFContext();
    const { i18n } = useContext();
    const appKey = i18n.localeProperties.appKey;
    const router = useRouter();
    const route = useRoute();
    const {
      toggleCartSidebar,
      toggleMobileMenu,
      openSearchModal,
      closeSearchModal,
      isMobileMenuOpen,
      isSearchOpen,
    } = useUiState();
    // const appKey = i18n.localeProperties.appKey;

    const hideNavigation = computed(() => {
      const routesToHide = [i18n.t('PAGES.CHECKOUT'), i18n.t('PAGES.ORDER_CONFIRMATION'), i18n.t('PAGES.ONGOING_OR_REFUSED_PAYMENT')];

      return routesToHide.map(route => localePath(route)).includes(route?.value?.path)
    })

    const handleCartClick = async () => {
      //replace url once we replace for every method
      await router.push(localePath(i18n.t('PAGES.CART')));
      closeModals();
    };
    const isSimplifiedHeaderEnable = checkCMSFlag('simplified-header-flag', 'true');
    const handleAccountClick = async () => {
      if (!isAuthenticated) {
        await router.push(localePath(i18n.t('PAGES.LOGIN')));
      } else {
        await router.push(localePath(i18n.t('PAGES.PERSONAL_DETAILS')));
      }
      closeModals();
    };

    const handleHomeClick = async () => {
      await router.push(localePath("/"));
      closeModals();
    };

    const toggleSearchModal = () => {
      isSearchOpen.value ? closeSearchModal() : openSearchModal();
    }

    const closeModals = () => {
      if(isMobileMenuOpen.value) toggleMobileMenu();
      if(isSearchOpen.value) closeSearchModal();
    }

    const cartTotalItems = computed(() => useCheckoutStore.cartItemsCount[appKey] ?? 0);

    const getAccountActiveStatus = computed(() => {
      if(isMobileMenuOpen.value || isSearchOpen.value) return false;
      switch(route.value?.path) {
        case localePath(i18n.t('PAGES.LOGIN')):
        case localePath(i18n.t('PAGES.REGISTRATION')):
        case localePath(i18n.t('PAGES.MY_ACCOUNT')):
        case localePath(i18n.t('PAGES.PERSONAL_DETAILS')):
        case localePath(i18n.t('PAGES.ADDRESS_BOOK')):
        case localePath(i18n.t('PAGES.PURCHASE_HISTORY')):
          return true;
        default:
          return false;
      }
    })

    const focusSearchInput = (isInitialLoad = false) => {
      if(!isSearchOpen.value) {
        openSearchModal();
      }
      
      // Use a longer timeout for initial page load
      const timeoutDuration = isInitialLoad ? 300 : 100;
      
      setTimeout(() => {
        const searchInput = document.querySelector('#search');
        if (searchInput) {
          searchInput.focus();
        }
      }, timeoutDuration);
    }

    // Watch for hash changes
    const handleHashChange = (isInitialLoad = false) => {
      if (window.location.hash === '#search') {
        focusSearchInput(isInitialLoad);
      }
    };

    // Watch for route changes
    watch(() => route.value.hash, (newHash) => {
      if (newHash === '#search') {
        focusSearchInput(false);
      }
    });

    onMounted(() => {
      // Check hash on initial mount with longer timeout
      handleHashChange(true);
      // Add hash change listener for external changes
      window.addEventListener('hashchange', () => handleHashChange(false));
    });

    return {
      hideNavigation,
      isMobileMenuOpen,
      toggleCartSidebar,
      toggleMobileMenu,
      openSearchModal,
      cartTotalItems,
      handleAccountClick,
      handleHomeClick,
      handleCartClick,
      toggleSearchModal,
      getAccountActiveStatus,
      isSearchOpen,
      isSimplifiedHeaderEnable
    };
  },
};
